var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import terminalExampleCss from "./terminal-example.css.js";
let TerminalExampleComponent = class TerminalExampleComponent extends LitElement {
    getValue() {
        const slot = this.shadowRoot?.querySelector('slot.command');
        // @ts-ignore
        const slots = slot?.assignedNodes({ flatten: true });
        if (slots) {
            return slots[0].data.trim();
        }
        return "";
    }
    copyToClipboard() {
        navigator.clipboard.writeText(this.getValue());
    }
    render() {
        return html `
            <sl-button class="copy" size="small" @click=${this.copyToClipboard}>copy</sl-button>
            <pre><slot class="command"></slot></pre>
        `;
    }
};
TerminalExampleComponent.styles = terminalExampleCss;
TerminalExampleComponent = __decorate([
    customElement('terminal-example')
], TerminalExampleComponent);
export { TerminalExampleComponent };
